var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4573 39.4072V21.6641C59.4573 5.45766 55.6308 1.60124 39.4194 1.60124C-0.224478 1.34687 1.33712 -0.26536 1.60369 39.3767C1.60369 55.5832 5.43022 59.439 21.6416 59.439H35.0976C52.3215 59.7367 59.8904 58.5527 59.4573 39.4072ZM48.3089 42.872H44.0902C42.4932 42.872 42.0113 41.5764 39.1486 38.7149C36.6476 36.3047 35.5929 36.0034 34.9603 36.0034C34.0862 36.0034 33.8452 36.2444 33.8452 37.4491V41.2445C33.8452 42.2687 33.514 42.8714 30.8318 42.8714C26.3721 42.8714 21.461 40.16 17.9651 35.1598C12.7222 27.8398 11.3057 22.2967 11.3057 21.1822C11.3057 20.5497 11.5467 19.9775 12.752 19.9775H16.9708C18.0554 19.9775 18.447 20.4594 18.8691 21.5739C20.5985 27.2432 26.5228 36.6768 26.6131 31.2436V25.038C26.4325 22.2064 24.9258 21.9655 24.9258 20.9413C24.9258 20.4893 25.3479 19.9775 26.0104 19.9775H32.6393C33.5433 19.9775 33.8446 20.4295 33.8446 21.5135V29.8882C33.9593 31.8963 35.2086 31.1057 36.4664 29.7979C39.5097 26.424 41.649 21.1822 41.649 21.1822C41.9204 20.5497 42.4023 19.9775 43.4869 19.9775H47.7057C48.9714 19.9775 49.2422 20.6101 48.9714 21.5141C48.459 23.984 43.3063 31.2137 43.3063 31.2442C42.8543 31.9372 42.6738 32.2989 43.3063 33.112C44.5209 34.6248 53.3707 42.617 48.3089 42.872Z",
    fill: "#DCDADD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactVk);
export default __webpack_public_path__ + "static/media/contact_vk.0cb6fe7fa4df232fc65bbd129c876664.svg";
export { ForwardRef as ReactComponent };